type UserBasicsSaveRegistration = {
    save: () => void;
    disabled: boolean;
};

let registration: UserBasicsSaveRegistration | null = null;
const listeners = new Set<() => void>();

export const registerUserBasicsSave = (next: UserBasicsSaveRegistration | null) => {
    registration = next;
    listeners.forEach((listener) => listener());
};

export const subscribeUserBasicsSave = (listener: () => void) => {
    listeners.add(listener);
    return () => {
        listeners.delete(listener);
    };
};

export const getUserBasicsSave = () => registration;

export const triggerUserBasicsSave = () => {
    registration?.save();
};
